import { render } from "./CargaMasiva-Component.vue?vue&type=template&id=22e7f2f6"
import script from "./CargaMasiva-Component.vue?vue&type=script&lang=js"
export * from "./CargaMasiva-Component.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__